module.exports = {
	"7": {
		"3": [
			4,
			5,
			6,
			7,
			8
		],
		"4": [
			5,
			6,
			7,
			8
		],
		"5": [
			6,
			7,
			8
		],
		"6": [
			7,
			8
		],
		"7": [
			8
		],
		"8": []
	},
	"30": {
		"4": [
			5,
			6,
			7,
			8,
			9
		],
		"5": [
			6,
			7,
			8,
			9
		],
		"6": [
			7,
			8,
			9
		],
		"7": [
			8,
			9
		],
		"8": [
			9
		],
		"9": []
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/glossary/group-nesting.json
// module id = 1824
// module chunks = 2